import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {CLOSE__16} from '@homeaway/svg-defs/lib/defs/CLOSE__16';
import bwcImage from '../../../../../../images/bwc-badge.svg';
import translate from '../../../../../../utils/translations';
import {IconBullet} from '../../../../../IconBullet/IconBullet';

import './BWCMessaging.less';

export class BWCMessaging extends Component {
    static propTypes = {
        translations: PropTypes.shape({}),
    };

    static defaultProps = {
        translations: {},
    };

    render() {
        const {translations} = this.props;
        const bullets = [];

        for (let i = 1; i <= 3; i++) {
            bullets.push(
                <IconBullet
                    fillColor={'text-danger'}
                    icon={CLOSE__16}
                    key={`BWCMessaging__bullet-${i}`}
                    text={translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        `th.inbox.conversation.cancel.bwc.bullet${i}`
                    )}
                />
            );
        }

        return (
            <div className="BWCMessaging">
                <img
                    className="BWCMessaging__image"
                    src={(typeof bwcImage === 'function' && bwcImage()) || ''}
                />
                <h3>
                    {translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'th.inbox.conversation.cancel.bwc.title'
                    )}
                </h3>
                <p>
                    {translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'th.inbox.conversation.cancel.bwc.text',
                        {
                            brandName: translate(
                                translations,
                                'trav-dash/trav-home',
                                'messages',
                                'th.site.name'
                            ),
                        }
                    )}
                </p>
                <ul className="list-unstyled list--vertical-grid">{bullets}</ul>
            </div>
        );
    }
}
